import React from 'react';
import { Route } from '../Routing/types';
import {
  CookbookIndexPage,
  CookbookSearchPage,
  CookbookMealListPage,
  CookbookTagListPage,
  CookbookFavMealsPage,
  CookbookMealDetailsPage,
  CookbookTagMealsPage,
  TrackerAddCookbookMealPage,
  TrackerAddIngredientPage,
  TrackerScanBarCodeIngredientPage,
} from '@front-activerse/modules';

import { CATEGORY_ALL_COVER_IMAGE_URL, CATEGORY_ALL_NAME } from './consts';

import cookbookNavigation from '../navigation/mealsNavigation';

import { fetchRemoteConfigFields } from '../Firebase/firebaseRemoteConfig';
import { markNotificationAsClosed, getClosedNotifications } from '../Firebase/firebaseFirestoreDb';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: '/',
    element: (
      <CookbookIndexPage
        cookbookNavigation={cookbookNavigation}
        categoryAllCoverImageUrl={CATEGORY_ALL_COVER_IMAGE_URL}
        categoryAllName={CATEGORY_ALL_NAME}
        fetchRemoteConfigFields={fetchRemoteConfigFields}
        getClosedNotifications={getClosedNotifications}
        markNotificationAsClosed={markNotificationAsClosed}
      />
    ),
    private: true,
    title: dummy_t('meals.navbarTitle'),
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: `/category/:categoryId`,
    element: <CookbookMealListPage />,
    private: true,
    title: dummy_t(`app.default.navbarTitle`),
    disableTitleChangePostMsg: true,
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: `/tag/:dietTypeTagId`,
    element: <CookbookTagListPage />,
    private: true,
    title: dummy_t(`app.default.navbarTitle`),
    disableTitleChangePostMsg: true,
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: `/tag/:dietTypeTagId/:mealTypeTagId`,
    element: <CookbookMealListPage />,
    private: true,
    title: dummy_t(`app.default.navbarTitle`),
    disableTitleChangePostMsg: true,
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/favourite-meals',
    element: <CookbookFavMealsPage />,
    private: true,
    title: dummy_t('cookbook.favorites.navbarTitle'),
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/search',
    element: <CookbookSearchPage />,
    private: true,
    title: dummy_t('cookbook.search.navbarTitle'),
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/meals-by-tag/:tagType/:tagId',
    element: <CookbookTagMealsPage />,
    private: true,
    title: dummy_t('app.default.navbarTitle'),
    disableTitleChangePostMsg: true,
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/meal-details/:mealId',
    element: <CookbookMealDetailsPage />,
    private: true,
    title: dummy_t('cookbook.recipeDetails.navbarTitle'),
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/module/tracker/add-meal/:dietMealId',
    element: <TrackerAddCookbookMealPage />,
    private: true,
    title: 'tracker.logMeal.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/module/tracker/add-meal/:dietMealId/add-ingredient/',
    element: <TrackerAddIngredientPage />,
    private: true,
    title: 'tracker.logMeal.addIngredient.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
  {
    path: '/module/tracker/add-meal/:dietMealId/add-ingredient/scan-barcode/',
    element: <TrackerScanBarCodeIngredientPage />,
    private: true,
    title: 'tracker.scanBarcode.navbarTitle',
    mobileAppTabIdentifier: 'diet',
  },
];

export default descendantRoutes;
